// src/components/music/views/SkeletonLoader.jsx

export const SkeletonLoader = ({ count = 6 }) => (
  <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
    {Array.from({ length: count }).map((_, i) => (
      <div 
        key={i} 
        className="relative bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20 overflow-hidden"
      >
        {/* Shimmer Effect Overlay */}
        <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/5 to-transparent"></div>

        {/* Music Icon/Cover Placeholder */}
        <div className="w-20 h-20 bg-white/10 rounded-xl mb-6 mx-auto border border-white/10"></div>
        
        {/* Title Placeholder */}
        <div className="h-4 bg-white/20 rounded-full mb-3 w-full"></div>
        
        {/* Subtitle Placeholder */}
        <div className="h-3 bg-white/10 rounded-full w-2/3 mx-auto mb-6"></div>
        
        {/* Button Placeholder */}
        <div className="h-10 bg-white/5 rounded-lg w-full border border-white/10"></div>
      </div>
    ))}
  </div>
);